
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#BCBCBC","d":"M10 7.388L17.388 0 20 2.612 12.612 10 20 17.388 17.388 20 10 12.612 2.612 20 0 17.388 7.388 10 0 2.612 2.612 0 10 7.388z"}})])
          )
        }
      }
    